import BaseEntityService from "../baseEntityService";
import { BaseConnection } from "../../types/connection";

export abstract class BaseConnectionService<
  T extends BaseConnection,
> extends BaseEntityService<T> {
  protected constructor(protected readonly collectionEndpoint: string) {
    super(`v1/${collectionEndpoint}`);
  }

  async createEdge(
    data: Pick<T, "_from" | "_to"> & { metadata?: Record<string, any> }
  ): Promise<T> {
    try {
      const response = await this.httpClient.post(this.serviceUrlSuffix, {
        from_id: data._from,
        to_id: data._to,
        ...data.metadata,
      });
      return response.data;
    } catch (error) {
      console.error(
        `Failed to create edge in ${this.collectionEndpoint}:`,
        error
      );
      throw error;
    }
  }

  async fetchConnectedEdges(
    entityId: string,
    direction: "inbound" | "outbound",
    offset: number = 0,
    limit: number = 10,
    sort: string = "",
    params: Record<string, any> = {}
  ): Promise<{ data: T[]; total: number }> {
    try {
      const bodyParams = {
        ...params,
        ...(direction === "inbound" ? { _to: entityId } : { _from: entityId }),
      };
      const queryParams = {
        offset: String(offset),
        limit: String(limit),
        ...(sort && { sort }),
      };
      const queryString = new URLSearchParams(queryParams).toString();
      const response = await this.httpClient.post(
        `${this.serviceUrlSuffix}/query?${queryString}`,
        bodyParams
      );
      return {
        data: response.data.data,
        total: response.data.metadata.total,
      };
    } catch (error) {
      console.error(`Failed to fetch edges for entity ${entityId}:`, error);
      throw error;
    }
  }
}
